import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';
import Loadable from 'ui-component/Loadable';

const List = Loadable(lazy(() => import('./List')));
const Create = Loadable(lazy(() => import('./Create')));
const Update = Loadable(lazy(() => import('./Update')));
const View = Loadable(lazy(() => import('./View')))

const orderRoutes = [
    {
        path: '/orders/create',
        element: <Create />,
        auth: authRoles.admin
    },
    {
        path: '/orders',
        element: <List />,
        auth: authRoles.admin
    },
    {
        path: '/orders/edit/:id',
        element: <Update />,
        auth: authRoles.admin
    },
    {
        path: '/orders/view/:id',
        element: <View />,
        auth: authRoles.admin
    }
];

export default orderRoutes;